<template>
    <div class="aside">
        <div class="logo" :class="!collapsed ? 'pl24' : 'pl16'">
            <img src="../../assets/logo-menu.png" alt="" />
            <span v-if="!collapsed" class="ml8 mt8"></span>
        </div>
        <a-menu
            mode="inline"
            theme="dark"
            @click="select"
            :openKeys="openKeys"
            @openChange="openChange"
            v-model="selectedKeys"  
            :inlineCollapsed="collapsed"
        >
            <template v-for="item in routes">
                <!-- 第一次循环中需要展开 -->
                <a-sub-menu :key="item.name" v-if="item.meta.unfold">
                    <span slot="title">
                        <span
                            class="iconfont aside-icon"
                            :class="item.meta.iconType"
                            v-if="item.meta.iconType"
                        ></span>
                        <a-icon type="close" v-else />
                        <span>{{ item.meta.name }}</span>
                    </span>
                    <template v-for="ele in item.children">
                        <!-- 第二次循环中需要展开 -->
                        <a-sub-menu :key="ele.name" v-if="ele.meta.unfold">
                            <span slot="title">
                                <a-icon :type="ele.meta.iconType" />
                                <span>{{ ele.meta.name }}</span>
                            </span>
                            <!-- 第三次循环 -->

                            <template v-for="child in ele.children">
                                <a-sub-menu
                                    :key="child.name"
                                    v-if="child.meta.unfold"
                                >
                                    <span slot="title">
                                        <a-icon :type="child.meta.iconType" />
                                        <span>
                                            {{ child.meta.name }}
                                        </span>
                                    </span>
                                    <a-menu-item
                                        v-for="element in child.children"
                                        :key="element.name"
                                    >
                                        <a-icon :type="element.meta.iconType" />
                                        <span>{{ element.meta.name }}</span>
                                    </a-menu-item>
                                </a-sub-menu>
                                <a-menu-item v-else :key="child.name">
                                    <a-icon :type="child.meta.iconType" />
                                    <span>{{ child.meta.name }}</span>
                                </a-menu-item>
                            </template>
                        </a-sub-menu>
                        <!-- 第二次循环中不需要展开 -->
                        <a-menu-item
                            :key="ele.name"
                            v-if="!ele.meta.unfold && ele.meta.hide"
                        >
                            <!-- <a-icon :type="ele.meta.iconType" /> -->

                            <!-- <span>{{ele.name }}</span> -->
                            <span>{{ ele.meta.name }}</span>
                        </a-menu-item>
                    </template>
                </a-sub-menu>
                <!-- 第一次循环中不需要展开 -->
                <a-menu-item :key="item.name" v-else>
                    <!-- <a-icon :type="item.meta.iconType" /> -->
                    <span
                        class="iconfont aside-icon"
                        :class="item.meta.iconType"
                        v-if="item.meta.iconType"
                    ></span>
                    <a-icon type="close" v-else />
                    <span>{{ item.meta.name }}</span>
                </a-menu-item>
            </template>
        </a-menu>
    </div>
</template>

<script>
// import { Icon } from 'ant-design-vue';
// const IconFont = Icon.createFromIconfontCN({
//   scriptUrl: '//at.alicdn.com/t/font_950712_yolw5a2kfi.css',
// })
export default {
    data() {
        return {
            collapsed: false,
            routes: [],
            selectedKeys: [],
            active: "",
            openKeys: [],
            role: [],
            flag: false
        };
    },
    methods: {
        select(obj) {
            this.$router.push({
                name: obj.key
            });
        },
        // 设置当前菜单选中
        setActive() {
            // 获取 active name值
            let opt = this.$route.matched[0];        
            if (opt.meta.unfold) {
                this.$set(this, "openKeys", [this.$route.matched[0].name]);
                this.active = this.$route.name;
            } else {
                this.active = opt.name;
            }
            this.selectedKeys = [this.$route.matched[1].name];
            console.log(this.selectedKeys)
        },
        openChange(openKeys) {
            const latestOpenKey = openKeys.find(
                key => this.openKeys.indexOf(key) === -1
            );
            let arr = latestOpenKey ? [latestOpenKey] : [];
            this.$set(this, "openKeys", arr);
        },
        updateRole() {
            if (!localStorage.authority) return;
            // this.flag = true;
            const routes = this.$router.options.routes;
            this.role = JSON.parse(localStorage.authority);
            // console.log(this.role);
            routes.forEach(it => {                
                it.meta.hide = false;                
                this.role.forEach(item => {
                    if (item.name === it.meta.name) {
                        it.meta.hide = true;
                        if (it.children.length > 1) {
                            it.children.forEach(el => {
                                item.child.forEach(ele => {
                                    if (ele.name === el.meta.name) {
                                        el.meta.hide = true;
                                        el.meta.role = {};
                                        if (ele.name === "资讯管理") {
                                            el.meta.role.knowList =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "资讯列表"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.lineList =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "头条列表"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.knowDetail =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "资讯详情"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.lineDetail =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "头条详情"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.knowEdits =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "编辑"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.lineEdits =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "编辑头条"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.knowAdd =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "新增"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.lineAdd =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "新增头条"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.knowDel =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "删除资讯"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.lineDel =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "删除头条"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                        } else {
                                            el.meta.role.add =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "新增"
                                                        ) !== -1
                                                    );
                                                }).length > 0 ||
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "增加"
                                                        ) !== -1
                                                    );
                                                }).length > 0 ||
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "添加"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.delete =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "删除"
                                                        ) !== -1
                                                    );
                                                }).length > 0 ||
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "取消"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.forbidden =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "禁用"
                                                        ) !== -1
                                                    );
                                                }).length > 0
                                            el.meta.role.edits =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "编辑"
                                                        ) !== -1
                                                    );
                                                }).length > 0 ||
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "维护"
                                                        ) !== -1
                                                    );
                                                }).length > 0 ||
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "修改"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.detail =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "详情"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.download =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "excel下载"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.cacelload =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "excel下载取消"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.dispatchs =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "派单"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.category =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "废品类目"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.sort =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "分拣中心列表"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.start =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "导出任务"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.waybill =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "生成运单"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                                //
                                                el.meta.role.openWrit =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "开票"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.windUp =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "结算"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.merge =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "生成账单"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.carList =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "车辆司机列表"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.dispatch =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "运单调度"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.driverList =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "司机列表"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.fleetList =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "车队列表"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.bindDriver =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "绑定司机"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.approve =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "审核"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.moveUp =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "上移"
                                                        ) !== -1
                                                    );
                                                }).length > 0;
                                            el.meta.role.moveDown =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "下移"
                                                        ) !== -1
                                                    );
                                            }).length > 0;
                                            el.meta.role.pays =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "支付"
                                                        ) !== -1
                                                    );
                                            }).length > 0;
                                            el.meta.role.unbund =
                                                ele.child.filter(its => {
                                                    return (
                                                        its.name.indexOf(
                                                            "解绑"
                                                        ) !== -1
                                                    );
                                            }).length > 0;
                                        }
                                    } else {
                                        //  el.meta.hide = false;
                                        
                                    }                           
                                });
                            });
                        } else {
                            it.children.forEach(el => {
                                item.child.forEach(ele => {
                                    let role = {
                                        add: false,
                                        approve: false,
                                        bind: false,
                                        detail: false,
                                        edits: false,
                                        forbidden: false,
                                        list: false,
                                        recovery: false,
                                        unbund: false,
                                        balance:false,
                                        changeaccount:false,
                                        changephone:false
                                    };
                                    if (ele.name === el.meta.name) {
                                        el.meta.hide = true;
                                    }
                                    role.list =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("列表") !== -1 && its.name.indexOf("待审核") === -1
                                            );
                                        }).length > 0;
                                        role.audit =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("待审核") !== -1
                                            );
                                        }).length > 0;
                                    role.add =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("新增") !== -1
                                            );
                                        }).length > 0;
                                    role.detail =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("详情") !== -1
                                            );
                                        }).length > 0;
                                    role.forbidden =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("禁用") !== -1
                                            );
                                        }).length > 0 ||
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("冻结") !== -1
                                            );
                                        }).length > 0 ||
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("拉黑") !== -1
                                            );
                                        }).length > 0;
                                    role.recovery =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("恢复") !== -1
                                            );
                                        }).length > 0;
                                    role.edits =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("编辑") !== -1
                                            );
                                        }).length > 0 ||
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("维护") !== -1
                                            );
                                        }).length > 0 ||
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("修改") !== -1
                                            );
                                        }).length > 0;
                                    role.approve =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("审核") !== -1 && its.name.indexOf("待审核") === -1
                                            );
                                        }).length > 0;
                                    role.unbund =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("解绑") !== -1
                                            );
                                        }).length > 0;
                                    role.balance =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("绿叶币修改") !== -1
                                            );
                                        }).length > 0;  
                                    role.changeaccount =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("修改卡号") !== -1
                                            );
                                        }).length > 0; 
                                    role.changephone =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("修改手机号") !== -1
                                            );
                                        }).length > 0;
                                    role.bind =
                                        ele.child.filter(its => {
                                            return (
                                                its.name.indexOf("绑定") !== -1
                                            );
                                        }).length > 0;
                                    
                                    if (el.meta.name === "用户管理") {
                                        if (ele.name === "普通用户") {
                                            el.meta.role1 = role;
                                        } else if (ele.name === "回收用户") {
                                            el.meta.role2 = role;
                                        } else if (ele.name === "兑换用户") {
                                            el.meta.role3 = role;
                                        } else if (ele.name === "分拣中心") {
                                            el.meta.role4 = role;
                                        }
                                    } else {
                                        el.meta.role = role;
                                    }
                                });
                            });
                        }
                    }
                });
            });
            this.routes = routes.filter(el => {
                return el.meta.hide;
            });           
        }
    },
    components: {
        // IconFont,
    },
    watch: {
        $route: {
            handler: function(val, oldVal) {
                // this.selectedKeys = [val.name];
                this.setActive();
            },
            // 深度观察监听
            deep: true
        }
    },
    mounted() {
        this.$eventBus.on("updateRole", () => {
            this.updateRole();
        });
        this.$eventBus.on("updateCollapse", data => {
            this.collapsed = data.status;
        });
    },
    created() {
        this.setActive();
        this.updateRole();
    }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.aside {
    background: #001529;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.35);
    z-index: 1000;
    min-height: 100%;
    &::-webkit-scrollbar {
        display: none;
    }
    .logo {
        height: 64px;
        display: flex;
        align-items: center;
        background: #002140;
        img {
            display: block;
            width: 36px;
            // height: 36px;
            border-radius: 100%;
        }
        span {
            @include pxAndLh(20);
            color: #fff;
            font-style: italic;
            width: 85px;
            height: 22px;
            background: url("../../assets/logo-menu-2.png") no-repeat;
            background-size: cover;
        }
    }

    .ant {
        &-menu {
            &-inline {
                width: 256px;

                &-collapsed {
                    width: 64px;
                }

                .ant-menu-item {
                    margin-top: 0;
                    height: 54px;
                    line-height: 54px;

                    &:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }

            &-inline-collapsed {
                .ant-menu-item,
                .ant-menu-submenu > .ant-menu-submenu-title {
                    padding: 0 25px !important;
                }
            }

            &-submenu {
                &-inline {
                    div.ant-menu-submenu-title {
                        margin-top: 0;
                        margin-bottom: 0;
                        height: 54px;
                        line-height: 54px;
                    }
                }
            }
        }
    }
    &-icon {
        font-size: 14px;
        margin-right: 10px;
    }
    // .anticon:before{
    //     display: none;
    // }
}
.ant-menu-inline-collapsed
    > .ant-menu-submenu
    > .ant-menu-submenu-title
    .aside-icon
    + span,
.ant-menu-inline-collapsed > .ant-menu-item .aside-icon + span {
    max-width: 0;
    display: inline-block;
    opacity: 0;
}
</style>
